import request from '../common/request.js'

export function getNewList(params) {
    return request({
        url: '/z-other/new/mobile',
        params
    })
}

export function getMobileHot() {
    return request({
        url: '/z-other/new/mobile-hot'
    })
}

export function getMobileRecommend() {
    return request({
        url: '/z-other/new/mobile-recommend'
    })
}

export function getNewDetail(id) {
    return request({
        url: '/z-other/new/by/id/' + id,
    })
}

export function updateHistory(id) {
    return request({
        url: '/z-other/new/history/by/id/' + id,
    })
}